export default __webpack_public_path__ + "static/media/success.6776e7db.png";